import React from "react";

export default function Datenschutz() {
  const currentYear = new Date().getFullYear();

  return (
    <div
      style={{
        padding: "3rem 2rem",
        maxWidth: "900px",
        margin: "0 auto",
        lineHeight: "1.6",
        fontFamily: "'Inter', Arial, sans-serif",
        color: "#222",
      }}
    >
      <header style={{ borderBottom: "3px solid #d44", marginBottom: "2rem" }}>
        <div className="pt-6" />
        <h1 style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>Datenschutzerklärung</h1>
        <p style={{ color: "#666", marginBottom: "1rem" }}>
          Informationen zur Verarbeitung personenbezogener Daten gemäß Art. 13 DSGVO
        </p>
      </header>

      {/* --- Verantwortlicher --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>1. Verantwortlicher</h2>
        <p>
          <strong>Dr.-Ing. Eike Radeisen – Erdwärme-Experten</strong><br />
          {/* Bitte echte Anschrift einfügen */}
          Brahmsstraße 1<br />
          14193 Berlin<br />
          Deutschland
        </p>
        <p>
          E-Mail:{" "}
          <a href="mailto:info@erdwaerme-experten.de">
            info@erdwaerme-experten.de
          </a>
          <br />
          Website: www.erdwaerme-experten.de
        </p>
      </section>

      {/* --- Arten der verarbeiteten Daten --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>
          2. Verarbeitete Daten
        </h2>
        <p>
          Beim Besuch unserer Website und bei Nutzung unserer Dienste verarbeiten wir
          insbesondere folgende Daten:
        </p>
        <ul>
          <li>IP-Adresse, Datum und Uhrzeit des Zugriffs</li>
          <li>Browsertyp und Betriebssystem</li>
          <li>Eingegebene Adressdaten für Standort- und Geothermieanalysen</li>
          <li>Formular- und Kontaktdaten (Name, E-Mail, Nachricht)</li>
          <li>Daten zur Zahlungsabwicklung (über Stripe)</li>
          <li>E-Mail-Adresse für Versand von Reports (via Resend)</li>
        </ul>
        <p>
          Rechtsgrundlagen: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung), Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse) sowie Art. 6 Abs. 1 lit. a DSGVO (Einwilligung, sofern erforderlich).
        </p>
		<p>
		  Sofern die Verarbeitung auf einer Einwilligung beruht, kann diese jederzeit
		  mit Wirkung für die Zukunft widerrufen werden.
		</p>

      </section>

      {/* --- Hosting & technische Dienste --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>3. Hosting & technische Infrastruktur</h2>

        <p><strong>Frontend-Hosting:</strong> Die Website wird über Vercel (USA/EU) bereitgestellt.</p>
        <p><strong>Backend-Server:</strong> Das Backend läuft bei Render (USA/EU).</p>
		<p>
		  Sofern Daten in Drittstaaten (z. B. USA) verarbeitet werden, erfolgt dies auf
		  Grundlage von Standardvertragsklauseln der EU-Kommission oder eines
		  Angemessenheitsbeschlusses gemäß Art. 44 ff. DSGVO.
		</p>
        <p>
          Beim Aufruf der Website fallen technische Log-Daten an, die automatisch verarbeitet
          werden. Eine Auswertung findet ausschließlich zur Stabilität und Sicherheit statt.
        </p>

        <p>Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO.</p>
      </section>
	  <section style={{ marginBottom: "2rem" }}>
		  <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>
			3a. Webanalyse (Vercel Analytics)
		  </h2>
		  <p>
			Diese Website nutzt Vercel Analytics, einen Webanalysedienst der Vercel Inc.
			Die Analyse erfolgt ohne den Einsatz von Cookies.
		  </p>
		  <p>
			Es werden ausschließlich aggregierte, anonymisierte Nutzungsdaten erhoben,
			insbesondere Seitenaufrufe und technische Zugriffsdaten. Eine Identifikation
			einzelner Nutzer ist nicht möglich.
		  </p>
		  <p>
			Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der
			Analyse der Nutzung zur Verbesserung der Website).
		  </p>
		</section>


      {/* --- Externe Geodatenquellen --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>4. Nutzung externer Geodatenquellen</h2>
        <p>
          Für Standortbewertung und Geothermie-Analyse werden WMS/WFS-Geodaten verschiedener
          deutscher Landesämter serverseitig abgefragt. Es werden dabei <strong>keine personenbezogenen Daten</strong> an diese Datenquellen übermittelt.
        </p>

        <p>
          Zusätzlich nutzen wir den Geocoding-Dienst <strong>Nominatim (OpenStreetMap)</strong>,
          um eingegebene Adressen in Koordinaten umzuwandeln. Dabei wird die eingegebene Adresse an Nominatim übertragen.
        </p>

        <p>Rechtsgrundlage: Art. 6 Abs. 1 lit. b und lit. f DSGVO.</p>
      </section>

      {/* --- Stripe Zahlungsabwicklung --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>5. Zahlungsabwicklung über Stripe</h2>
        <p>
          Für Zahlungen über unsere Website nutzen wir den Dienstleister{" "}
          <strong>Stripe Payments Europe, Ltd.</strong> (Irland).
        </p>
        <p>Verarbeitete Daten:</p>
        <ul>
          <li>E-Mail-Adresse</li>
          <li>Zahlungsinformationen (Kartendaten ausschließlich bei Stripe!)</li>
          <li>Rechnungs- und Metadaten</li>
          <li>IP-Adresse, Browser-Daten</li>
        </ul>

        <p>
          Stripe verarbeitet Zahlungsdaten in eigener Verantwortung. Unsere Systeme speichern
          keinerlei vollständige Zahlungsinformationen.
        </p>

        <p>Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO.</p>
      </section>

      {/* --- Email Versand über Resend --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>
          6. Versand von E-Mails und Reports (Resend)
        </h2>
        <p>
          Für den Versand automatischer E-Mails und PDF-Reports nutzen wir den Anbieter{" "}
          <strong>Resend</strong>.
        </p>
        <p>Dabei werden übermittelt:</p>
        <ul>
          <li>E-Mail-Adresse</li>
          <li>Name (falls angegeben)</li>
          <li>Bestelldaten und Report-Metadaten</li>
        </ul>
        <p>
          Resend verarbeitet Daten teilweise auch außerhalb der EU. Es bestehen Standardvertragsklauseln gemäß Art. 46 DSGVO.
        </p>
      </section>
	  <section style={{ marginBottom: "2rem" }}>
		  <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>
			Keine automatisierten Entscheidungen
		  </h2>
		  <p>
			Es findet keine automatisierte Entscheidungsfindung oder Profiling im Sinne
			des Art. 22 DSGVO statt.
		  </p>
		</section>


      {/* --- Kontaktformular --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>7. Kontaktaufnahme</h2>
        <p>
          Bei Nutzung unseres Kontaktformulars werden Name, E-Mail-Adresse und Nachricht
          gespeichert, um Ihre Anfrage zu beantworten.
        </p>
        <p>
          Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO.
        </p>
      </section>

      {/* --- Betroffenenrechte --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>8. Rechte der betroffenen Personen</h2>
        <p>Sie haben jederzeit das Recht:</p>
        <ul>
          <li>Auskunft zu verlangen (Art. 15 DSGVO)</li>
          <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
          <li>Löschung zu verlangen (Art. 17 DSGVO)</li>
          <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
          <li>Widerspruch einzulegen (Art. 21 DSGVO)</li>
          <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
        </ul>

        <p>
          Zur Ausübung Ihrer Rechte genügt eine E-Mail an:<br />
          <a href="mailto:info@erdwaerme-experten.de">info@erdwaerme-experten.de</a>
        </p>
      </section>

      {/* --- Beschwerden --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>9. Beschwerderecht</h2>
        <p>
          Sie können sich gemäß Art. 77 DSGVO bei der zuständigen
          Datenschutz-Aufsichtsbehörde beschweren. Zuständig: Berlin.
        </p>
      </section>

      {/* --- Speicherfristen --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>
          10. Speicherdauer
        </h2>
        <p>
          Wir speichern personenbezogene Daten nur so lange, wie dies für die jeweiligen
          Zwecke erforderlich ist oder gesetzliche Aufbewahrungsfristen bestehen.
        </p>
      </section>

      {/* --- Footer --- */}
      <footer style={{ borderTop: "1px solid #ddd", paddingTop: "1rem", color: "#555" }}>
        <p>© {currentYear} Dr.-Ing. Eike Radeisen – Erdwärme-Experten. Alle Rechte vorbehalten.</p>
      </footer>
    </div>
  );
}
